import { Flex as InstUIFlex } from '@instructure/ui-flex';
import React, { forwardRef } from 'react';
import { FlexItem } from '../FlexItem';
var FlexComponent = forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(InstUIFlex, Object.assign({}, props, {
    ref: ref
  }));
});

/**
 * This is a wrapper around the InstUI Flex component.
 */
export var Flex = FlexComponent;
Flex.Item = FlexItem;
Flex.displayName = 'Flex';